export default {
  plan: {
    annual: {
      title: 'Annual Plan',
      subtitle: 'Set annual business plans with core targets like total income and lease rate',
      listTitle: 'Annual Plan List',
      planName: 'Plan Name',
      planYear: 'Plan Year',
      orgName: 'Organization',
      orgRequired: 'Please select an organization',
      planStatus: 'Plan Status',
      totalIncomeTarget: 'Total Income Target',
      noiTarget: 'NOI Target',
      leaseRateTarget: 'Lease Rate Target',
      budgetTotal: 'Total Budget',
      autoCalc: 'Auto',
      preparedBy: 'Prepared By',
      approvedBy: 'Approved By',
      approvalDate: 'Approval Date',
      description: 'Description',
      status: {
        DRAFT: 'Draft',
        PENDING_APPROVAL: 'Pending Approval',
        APPROVED: 'Approved',
        ACTIVE: 'Active',
        COMPLETED: 'Completed',
        ADJUSTING: 'Adjusting'
      },
      create: 'Create Annual Plan',
      edit: 'Edit Annual Plan',
      submit: 'Submit for Approval',
      approve: 'Approve',
      activate: 'Activate',
      delete: 'Delete',
      selectPlaceholder: 'Select Annual Plan',
      submitConfirm: 'Confirm to submit for approval?',
      activateConfirm: 'Confirm to activate? The plan execution cycle will begin.',
      deleteConfirm: 'Confirm to delete this plan?',
      detailTab: {
        overview: 'Overview',
        deptTarget: 'Dept Targets',
        quarterly: 'Quarterly',
        task: 'Tasks',
        kpi: 'KPI Monitor',
        review: 'Reviews'
      },
      steps: {
        create: 'Create Plan',
        setTarget: 'Set Targets',
        splitQuarter: 'Split Quarterly',
        activate: 'Activate',
        monitor: 'Monitor',
        complete: 'Review'
      },
      summarySource: {
        title: 'Target Sources',
        noTargetHint: 'Please initialize targets in "Dept Targets" tab first',
        fromIndicator: 'from indicator'
      },
      submitValidation: {
        incompleteTitle: 'Plan Incomplete',
        noTargets: 'No department targets set. Please initialize and set targets in the detail page first',
        emptyTargets: 'Department targets created but annual values are empty. Please complete target data first',
        noQuarters: 'No quarterly plans split. Please split quarters in the detail page first'
      }
    },
    quarterly: {
      title: 'Quarterly Execution',
      quarter: 'Quarter',
      planName: 'Plan Name',
      quarterStatus: 'Status',
      keyTasks: 'Key Tasks',
      keyRisks: 'Key Risks',
      responsiblePerson: 'Responsible Person',
      status: {
        DRAFT: 'Draft',
        ACTIVE: 'Active',
        COMPLETED: 'Completed',
        ADJUSTING: 'Adjusting'
      },
      activateBtn: 'Activate',
      completeBtn: 'Complete',
      emptyMessage: 'No quarterly plans yet. Please decompose from annual plan first.'
    },
    task: {
      title: 'Task Execution',
      taskName: 'Task Name',
      department: 'Department',
      taskType: 'Task Type',
      targetValue: 'Target Value',
      actualValue: 'Actual Value',
      achievementRate: 'Achievement Rate',
      deadline: 'Deadline',
      assignedTo: 'Assigned To',
      priority: 'Priority',
      taskStatus: 'Task Status',
      progress: 'Progress',
      description: 'Description',
      actualResults: 'Actual Results',
      status: {
        PENDING: 'Pending',
        IN_PROGRESS: 'In Progress',
        COMPLETED: 'Completed',
        CANCELLED: 'Cancelled',
        OVERDUE: 'Overdue'
      },
      priorityMap: {
        HIGH: 'High',
        NORMAL: 'Normal',
        LOW: 'Low'
      },
      create: 'Create Task',
      edit: 'Edit Task',
      start: 'Start',
      updateProgress: 'Update Progress',
      complete: 'Complete',
      cancel: 'Cancel',
      startConfirm: 'Confirm to start execution?',
      progressPrompt: 'Enter current progress (0-100)',
      progressInputError: 'Please enter a number',
      completionPrompt: 'Enter completion details',
      cancelConfirm: 'Confirm to cancel this task?',
      taskNameRequired: 'Please enter task name'
    },
    indicator: {
      title: 'Indicator Management',
      subtitle: 'Manage KPI indicator definitions, support dynamic extension',
      indicatorCode: 'Indicator Code',
      indicatorName: 'Indicator Name',
      indicatorNameEn: 'English Name',
      deptCategory: 'Department Type',
      category: 'Category',
      unit: 'Unit',
      calcMode: 'Calc Mode',
      summaryRole: 'Summary Role',
      calcExpression: 'Calc Expression',
      dataSource: 'Data Source',
      sortOrder: 'Sort Order',
      status: 'Status',
      create: 'Create Indicator',
      edit: 'Edit Indicator',
      delete: 'Delete Indicator',
      codeRequired: 'Please enter indicator code',
      nameRequired: 'Please enter indicator name',
      deleteConfirm: 'Confirm to delete this indicator?',
      summaryRoleMap: {
        NONE: 'None',
        TOTAL_INCOME: 'Total Income',
        NOI: 'NOI',
        LEASE_RATE: 'Lease Rate',
        BUDGET: 'Budget'
      },
      calcModeMap: {
        AUTO: 'Auto Calculate',
        MANUAL: 'Manual Input',
        HYBRID: 'Hybrid'
      },
      unitMap: {
        PERCENT: '%',
        YUAN: 'Yuan',
        COUNT: 'Count',
        RATIO: 'Ratio'
      },
      categoryList: 'Efficiency,Revenue,Quality,Cost'
    },
    kpi: {
      title: 'KPI Monitoring',
      indicatorName: 'Indicator Name',
      targetValue: 'Target Value',
      actualValue: 'Actual Value',
      achievementRate: 'Achievement Rate',
      unit: 'Unit',
      refresh: 'Refresh KPI',
      trend: 'Trend',
      comparison: 'Comparison'
    },
    deptTarget: {
      annualTarget: 'Annual Target',
      responsiblePerson: 'Responsible Person',
      initTargets: 'Initialize Targets',
      initConfirm: 'Confirm to initialize? System will generate department KPI targets based on indicators and org structure.',
      initSuccess: 'Targets initialized successfully',
      editTarget: 'Edit KPI Target',
      weight: 'Weight',
      measurementRule: 'Measurement Rule',
      deptName: 'Department',
      emptyHint: 'No department targets yet. Click "Initialize Targets" to get started.',
      q1Target: 'Q1 Target',
      q2Target: 'Q2 Target',
      q3Target: 'Q3 Target',
      q4Target: 'Q4 Target',
      decompose: 'Decompose to Quarterly'
    },
    review: {
      title: 'Plan Review',
      reviewType: 'Review Type',
      reviewPeriod: 'Review Period',
      reviewDate: 'Review Date',
      summary: 'Summary',
      issues: 'Issues',
      lessons: 'Lessons Learned',
      actionItems: 'Action Items',
      score: 'Score',
      reviewStatus: 'Status',
      status: {
        DRAFT: 'Draft',
        PUBLISHED: 'Published'
      },
      type: {
        WEEKLY: 'Weekly Review',
        MONTHLY: 'Monthly Review',
        QUARTERLY: 'Quarterly Review',
        ANNUAL: 'Annual Review'
      },
      create: 'Create Review',
      edit: 'Edit Review',
      publish: 'Publish',
      periodPlaceholder: 'e.g. 2026-Q1',
      publishConfirm: 'Confirm to publish? This cannot be modified after publishing.',
      deleteConfirm: 'Confirm to delete this review?'
    },
    adjustment: {
      title: 'Plan Adjustment',
      adjustmentNo: 'No.',
      annualPlan: 'Annual Plan',
      targetIndicator: 'Target Indicator',
      originalValue: 'Original Value',
      proposedValue: 'Proposed Value',
      adjustmentReason: 'Adjustment Reason',
      effectiveDate: 'Effective Date',
      adjustmentStatus: 'Status',
      approvalComments: 'Approval Comments',
      status: {
        DRAFT: 'Draft',
        PENDING_APPROVAL: 'Pending Approval',
        APPROVED: 'Approved',
        REJECTED: 'Rejected'
      },
      create: 'Apply Adjustment',
      submit: 'Submit for Approval',
      approve: 'Approve',
      reject: 'Reject',
      submitConfirm: 'Confirm to submit for approval?',
      approvalPrompt: 'Enter approval comments (optional)',
      rejectionPrompt: 'Enter rejection reason',
      deleteConfirm: 'Confirm to delete this adjustment?',
      targetLabel: 'Target'
    },
    dashboard: {
      title: 'Management Dashboard',
      overview: 'Overview',
      alerts: 'Alerts',
      trend: 'Trend',
      noData: 'No Data',
      alertType: 'Type',
      alertContent: 'Alert Content',
      department: 'Department',
      alertDate: 'Date',
      noAlerts: 'No Alerts',
      taskStatusDistribution: 'Task Status Distribution',
      planOverview: 'Annual Plan Overview',
      planNameLabel: 'Plan Name',
      totalIncomeLabel: 'Total Income Target',
      noiTargetLabel: 'NOI Target',
      leaseRateLabel: 'Lease Rate Target',
      noActivePlan: 'No active annual plan',
      alertOverdue: 'Overdue Task',
      alertKpiLow: 'Low KPI',
      refreshBtn: 'Refresh',
      dept: {
        RECRUITMENT: 'Recruitment',
        OPERATIONS: 'Operations',
        FINANCE: 'Finance'
      }
    },
    report: {
      recruitment: 'Recruitment Report',
      operations: 'Operations Report',
      finance: 'Finance Report',
      targetVsActual: 'Target vs Actual',
      monthlyTrend: 'Monthly Trend',
      quarterlyComparison: 'Quarterly Comparison',
      annualTarget: 'Annual Target',
      q1: 'Q1',
      q2: 'Q2',
      q3: 'Q3',
      q4: 'Q4'
    }
  }
}
